<script lang="ts">
    import { getContext, onMount } from "svelte";
    import { navigate, Link } from "svelte-navigator";
    import type { Campaign, UpdateCampaignIn } from "../model";
    import { api, loader, swClient, toast } from "../stores";
    import BrandModal from "./BrandModal.svelte";
    import ConfirmPopup from "./../modals/ConfirmPopup.svelte";

    export let operationCode;
    export let shopCode = "0000";

    /**List of all trade Brands*/
    let tradeBrands: Array<{
        name: string;
        logo_url: string;
        ban_url: string;
    }> = [];
    /**List of displyed trade brands*/
    let tradeBrandsDisplayed: Array<{
        name: string;
        logo_url: string;
        ban_url: string;
        popup_url: string;
    }> = [];
    let operation: Campaign = null;
    /** list of brands on the operation*/
    let brands: string[] = [];
    let searchValue: string;

    const { open } = getContext("simple-modal");

    onMount(async () => {
        $api.setOperationCode(operationCode);
        $api.setShopId(shopCode);
        const loadIdGetOperation = $loader.show("Chargement de l'opération'");
        await $api.getOperationByCode().then(
            (op) => {
                $swClient.getCampaign(op.uid).then(
                    (campaign) => {
                        operation = campaign;
                        // find attr trade_brands
                        const attrBrand = operation.attrs.find(
                            (attr) => attr.key === "trade_brands"
                        );
                        if (attrBrand) {
                            tradeBrands = JSON.parse(attrBrand.value);
                            tradeBrandsDisplayed = JSON.parse(
                                JSON.stringify(tradeBrands)
                            );
                        }
                        $loader.hide(loadIdGetOperation);
                    },
                    (err) => {
                        console.error(err);
                        $loader.hide(loadIdGetOperation);
                    }
                );
            },
            (err) => {
                console.error(err);
                $loader.hide(loadIdGetOperation);
            }
        );
        const loadIdGetBrands = $loader.show(
            "Chargement de la liste des marques"
        );
        $api.getBrandsByOperation().then(
            (result) => {
                brands = result.sort();
                $loader.hide(loadIdGetBrands);
            },
            (err) => {
                console.error(err);
                $loader.hide(loadIdGetBrands);
            }
        );
    });

    /**
     * Called when removing a trade brand
     * Ask confirmation
     * @param brandIndex index of trade brand to remove
     */
    function onRemoveBrand(brandIndex: number) {
        open(
            ConfirmPopup,
            {
                onOkay: () => _removeBrandAsync(brandIndex),
                title: `Supprimer l'espace marque ${tradeBrands[brandIndex].name} ?`,
                content: "",
            },
            { closeOnOuterClick: false, closeOnEsc: false, closeButton: false }
        );
    }

    /**
     * Remove trade brand from the attr of the operation
     * @param brandIndex index of trade brand to remove
     */
    async function _removeBrandAsync(brandIndex: number) {
        const loaderBrandSuppr = $loader.show("Suppression de l'espace marque");

        const index = operation.attrs.findIndex((attr) => {
            return attr.key === "trade_brands";
        });
        if (index !== -1) {
            let tradeBrandsValue = JSON.parse(operation.attrs[index].value);
            tradeBrandsValue.splice(brandIndex, 1);
            operation.attrs[index].value = JSON.stringify(tradeBrandsValue);

            let newCampaign: UpdateCampaignIn = {
                name: operation.name,
                type_uid: operation.type.uid,
                attrs: operation.attrs,
                geo_area_uid: operation.geo_area.uid,
                description: operation.description,
                cover: operation.cover,
            };
            try {
                await $swClient.putCampaign(operation.uid, newCampaign);
                $toast.success("Sauvegarde effectuée avec succès.");
                tradeBrands.splice(brandIndex, 1);
                tradeBrands = tradeBrands;
                filterBrand();
                // close();
            } catch (err) {
                $toast.error(`Une erreur s'est produite : ${err}.`);
            } finally {
                $loader.hide(loaderBrandSuppr);
            }
        }
    }

    /**
     * Open the creation:update modal
     * @param brand
     */
    function openBrandModal(
        brand: {
            name: string;
            logo_url: string;
            ban_url: string;
            popup_url: string;
        },
        index?: number
    ) {
        open(BrandModal, {
            onClose,
            brand,
            brandList: brands,
            campaign: operation,
            brandIndex: index,
        });
    }

    /**
     * filter trade brand list with the search value
     */
    function filterBrand() {
        tradeBrandsDisplayed = tradeBrands.filter(
            (tb) => !searchValue || tb.name.toLowerCase().includes(searchValue)
        );
    }

    /**
     * Navigate to the catalog og the operation
     */
    function gotoCatalog() {
        navigate(`/admin/catalog/${operationCode}/0100`);
    }

    /**
     * Reset trade brand list after creation or edition
     * @param campaign
     */
    const onClose = (campaign: Campaign) => {
        const attrBrand = campaign.attrs.find(
            (attr) => attr.key === "trade_brands"
        );
        if (attrBrand) {
            tradeBrands = JSON.parse(attrBrand.value);
            filterBrand();
        }
    };
</script>

{#if operation}
    <div id="content" class="container-fluid p-3">
        <div id="header">
            <!-- svelte-ignore a11y-missing-attribute -->
            <h1 class="title m-title">
                Espace marque de l'opération <a on:click={() => gotoCatalog()}
                    >{operation.name}</a
                >
            </h1>
            <div class="columns">
                <div class="column is-narrow">
                    <Link to="/admin" title="Retour aux opérations">
                        <button class="button is-light" id="backToAdmin">
                            <i class="fas fa-chevron-left" /><span
                                >&nbsp Retour aux opérations</span
                            ></button
                        >
                    </Link>
                </div>
                <div class="column pull-right">
                    <button
                        class="button btn-elpev"
                        on:click={() =>
                            openBrandModal({
                                name: null,
                                logo_url: null,
                                ban_url: null,
                            })}
                        disabled={!brands || brands.length == 0}
                    >
                        <span title="Créer">Créer un espace marque</span>
                    </button>
                </div>
            </div>
        </div>
        {#if tradeBrandsDisplayed.length > 0}
            <div class="columns header header-mobile">
                <div class="column is-one-fifth">Nom</div>
                <div class="column is-one-fifth">Miniature</div>
                <div class="column is-one-fifth">Bannière</div>
                <div class="column is-one-fifth">Popup</div>
                <div class="column is-one-fifth">Actions</div>
            </div>
            {#each tradeBrandsDisplayed as brand, i}
                <div class="brand-line columns {i % 2 === 0 ? 'bg-white' : ''}">
                    <div class="column is-one-fifth">
                        <span title={brand.name}>{brand.name}</span>
                    </div>
                    <div class="column is-one-fifth">
                        <img
                            title={brand.name}
                            class="max-logo"
                            src={brand.logo_url}
                            alt="Chargement de l'image:{brand.name}"
                        />
                    </div>
                    <div class="column is-one-fifth">
                        <img
                            title={brand.name}
                            class="max-ban"
                            src={brand.ban_url}
                            alt="Chargement de l'image:{brand.name}"
                        />
                    </div>
                    <div class="column is-one-fifth">
                        {#if brand.popup_url}
                            <img
                                title={brand.name}
                                class="max-pop"
                                src={brand.popup_url}
                                alt="Chargement de l'image:{brand.name}"
                            />
                        {:else}
                            <p>Pas de popup renseignée</p>
                        {/if}
                    </div>
                    <div class="column is-one-fifth align-items-center">
                        <div class="buttons">
                            <button
                                class="button is-dark btn-elpev"
                                title="Editer"
                                on:click={() => openBrandModal(brand, i)}
                                ><i class="fas fa-pen" />
                            </button>
                            <button
                                class="button is-danger"
                                title="Supprimer"
                                on:click={() => onRemoveBrand(i)}
                                ><i class="fas fa-times" /></button
                            >
                        </div>
                    </div>
                </div>
            {/each}
        {:else}
            <!-- svelte-ignore a11y-missing-attribute -->
            <h1>
                Aucun espace marque.
                {#if brands && brands.length > 0}
                    <a
                        on:click={() =>
                            openBrandModal({
                                name: null,
                                logo_url: null,
                                ban_url: null,
                                popup_url: null,
                            })}>Créez-en un !</a
                    >
                {:else}
                    Il faut créer des produits contenant des marques pour créer
                    un espace marque.
                {/if}
            </h1>
        {/if}
    </div>
{/if}

<style lang="scss">
    @import "../styles/variables.scss";

    #content {
        max-height: 100em;
        overflow-y: auto;
        overflow-x: hidden;
    }
    #header {
        width: 100%;
        margin-bottom: 10px;
    }

    .button.is-danger {
        border-radius: 10px;
    }

    .header {
        background-color: $beige !important;
        border-radius: 12px;
        .column {
            color: black;
            font-weight: 900 !important;
            font-family: "Gilmer Bold" !important;
        }
    }
    .columns {
        margin: 2rem;
    }

    .m-title {
        margin-top: 2rem;
        margin-bottom: 2rem;
        margin-left: 2rem;
        a {
            font-size: 2rem;
            font-weight: 900;
            color: $dark-mauve;
            font-family: "Gilmer Bold" !important;
        }
    }
    .max-logo {
        max-width: 150px;
        max-height: 150px;
    }

    .max-ban {
        // max-width: 480px;
        // max-height: 108px;
        width: auto;
        height: 100%;
        max-width: 200px;
    }

    .max-pop {
        // max-width: 480px;
        // max-height: 108px;
        width: auto;
        height: 100%;
        max-width: 200px;
    }

    .brand-line {
        align-items: center;
        border: 1px solid $grey-light;
        border-radius: 12px;
        &:hover {
            box-shadow: 0px 2px 8px $dark-mauve;
        }
    }
    .align-items-center {
        align-items: center;
    }

    .pull-right {
        text-align: right;
        margin-right: 5rem;
    }

    @media (max-width: $mobile-breakpoint) {
        .header-mobile {
            display: none;
        }
    }
</style>
